import { render, staticRenderFns } from "./AllTipsDialog.vue?vue&type=template&id=aae876f2&scoped=true"
import script from "./AllTipsDialog.vue?vue&type=script&lang=js"
export * from "./AllTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./AllTipsDialog.vue?vue&type=style&index=0&id=aae876f2&prod&lang=sass"
import style1 from "./AllTipsDialog.vue?vue&type=style&index=1&id=aae876f2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae876f2",
  null
  
)

export default component.exports